import React from 'react';
import { FDAlert } from '@facet-wealth/design';

export const Disclosure = ({ value, status = 'info' }) => {
  return (
    <FDAlert description={value} status={status} />
  );
};
